import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  type?: 'info' | 'success' | 'warning' | 'danger' | 1 | 2 | 3 | 4 | 5;
}>;

const Badge = React.forwardRef<HTMLSpanElement, Props>(props => {
  const { type, children } = props;
  const classNames = cn('badge', { [`badge-${type}`]: type });

  return <span className={classNames}>{children}</span>;
});

export default Badge;
